import $ from 'jquery'
import { gsap } from "gsap";
import { appendBlogGridItems } from './main';

const section = $(".blog-landing-grid")
if(section.length > 0) {

    let termId = section.attr('data-term-id')
    let off = 20
    let loading = false
    let loadMore = true

    $(window).on('scroll', function() {
        checkForBlogReload()
    })

    $(window).on('load', function() {
        checkForBlogReload()
    })

    function checkForBlogReload() {
        if($(window).scrollTop() >= $('.blog-landing-grid').offset().top + $('.blog-landing-grid').outerHeight() - window.innerHeight) loadBlogPosts()
    }

    function loadBlogPosts() {

        if(loading || !loadMore) return
        loading = true

        $(".loading").addClass('active')

        let type = $(".blog-landing-grid").hasClass('talks-landing-grid') ? 'talk' : 'post';
        
        var data = {
            action: 'base1_ajax_load_more',
            offset: off,
            term: termId,
            type: type,
            tax: type == 'post' ? 'category' : 'talk_categories',

        };
        $.post(base1loadmore.url, data, function(res) {
          if(res) {
            off += 20

            var $items = $( $.parseHTML(res.trim()) );
            if($items.length){
              $(".blog-landing-grid").append($items);
              appendBlogGridItems($items)

              if($('.last-page').length > 0) {
                $(".loading").hide();
                loadMore = false
              }
              
            } else{
                $(".loading").hide();
            }
            $(".loading").removeClass('active')            
          } else {
            $(".loading").hide();
          }
          loading = false
        }).fail(function(xhr, textStatus, e) {
            loading = false
        }).done(function(){
            loading = false
        });
    }
}
